import { PHP_API_URL } from "../../../util/constants";
import request from "../../../util/request";
import Cookies from 'js-cookie';
// bot_id用户删除数据库智能体，bot_name用户更新coze智能体名称
export function deleteBotRequest(bot_id,bot_name, callback) {
    return request(
        '/deleteBot',
        {
            method: 'POST',
            body: {
                "userToken":Cookies.get("userToken"),
                bot_id,
                bot_name
            },
        },
        callback
    );
}



export function getEduBotsListRequest( callback) {
    return request(
        '/getEduBotList',
        {
            method: 'POST',
            body: {
                "userToken":Cookies.get("userToken"),
                page_num:'0',
                page_size:'100000000',
            },
        },
        callback
    );
}


//删除知识库接口
export function delDatasets(data, callback) {
    return request(
        '/zhishiku/deldatasets',
        {
            method: 'POST',
            body: data,
        },
        callback
    );
}

export function getVideoPlayerAuthRequest(VideoId, callback) {
    let formData = new FormData();
    // formData.append('caozuo', "xuexi_shiti");
    formData.append('VideoId', VideoId);
    return request(PHP_API_URL+"/aliyun/getplayauth.php", {
        method: "POST",
        body: formData
    }, callback);
}

export function getSchoolBotListRequest(callback) {
    let formData = new FormData();
    formData.append('appkey', 'spark');
    formData.append('caozuo', 'get_school_code_bot_list');
    formData.append('school_code', Cookies.get('school_code'));
    return request('https://ygbh.gamification.org.cn/School_bot/i', {
        method: "POST",
        body: formData
    }, callback);
}